// extracted by mini-css-extract-plugin
export default {"container":"Works_container__MFNab","introBox":"Works_introBox__n8Adk","introText":"Works_introText__EbQKG"};